/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { CBQScenarioDTO } from "./InitCBQScenario";

type GetAdminCBQScenariosResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: CBQScenarioDTO[];
};

const unwrapList = (payload: any): CBQScenarioDTO[] => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.items)) return payload.items;
  if (Array.isArray(payload?.scenarios)) return payload.scenarios;
  return [];
};

// GET /admin/cbq/exams/:cbqExamId/scenarios
export const GetAdminCBQScenarios = async (
  examId: string
): Promise<GetAdminCBQScenariosResponse> => {
  try {
    const response = await axios.get(`/admin/cbq/exams/${examId}/scenarios`);
    return { data: unwrapList(response.data?.data ?? response.data) };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      if (error.response.status === 404) return { data: [] };
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data?.message,
        error: error.response.data?.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
